module.exports = __webpack_public_path__ + "img/prestogo_small.25fc01b4.png";